export default "__VITE_ASSET__DnS3MTaP__"